import * as React from 'react';
import { connect } from 'react-redux';
import Row from 'reactstrap/lib/Row';
import { Col, Button } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { IReduxState } from 'src/reduxTypes';
import { UserTypes } from 'src/modules/Auth/store/types';
import xmark from 'src/images/xmark-solid.svg';
import { momentToString, timestampToMoment } from 'src/share/utils/utils';

export interface IMatchDetailState {
  showDelete: boolean;
}

export interface IProps {
  [k: string]: any;
}

export class MatchDetail extends React.Component<IProps, IMatchDetailState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showDelete: false,
    };
  }

  public modalToggle = () => {
    this.setState({ showDelete: !this.state.showDelete });
  };

  public isAdmin() {
    return this.props.auth.userType === UserTypes.ADMIN;
  }

  public render() {
    const { url, href, createdAt, matchId, caseId, childId } = this.props;

    const containerStyle = Object.assign({
      height: 'auto',
      maxHeight: '250',
      display: 'inline-block',
      position: 'relative',
    });

    return (
      <Col md={12}>
        <Row>
          <Col md={12} className={'imageContainer'}>
            <div className="col-xs-12" style={containerStyle}>
              <div className="container-img">
                <img
                  src={url}
                  style={{ maxHeight: 250 }}
                  alt="Face"
                  onClick={() =>
                    this.props.onZoomImage({
                      source: url,
                      boundingBoxes: [{ box: {} }],
                    })
                  }
                />
              </div>
            </div>
            <div className="col-xs-12" style={containerStyle}>
              <div className="container-img">
                <img
                  onClick={() =>
                    this.props.onZoomImage({
                      source: `http://localhost:3000/api/webiq/image?url=${href}`,
                      boundingBoxes: [{ box: {} }],
                    })
                  }
                  style={{ maxHeight: 250 }}
                  src={`http://localhost:3000/api/webiq/image?url=${href}`}
                  alt="Face"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = xmark;
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md={12} className="stats-info">
            <p>
              <Label>Created at:</Label>
              {createdAt
                ? momentToString(timestampToMoment(createdAt))
                : 'Data not available'}
            </p>
            <p>
              <Label>Case ID:</Label>
              {caseId || 'Not available'}
            </p>
            <p>
              <Label>ChildId:</Label>
              {childId || 'Not available'}
            </p>
            <p>
              <Label>Source:</Label>
              {href ? <span className="subFont">{href}</span> : 'Not available'}
            </p>
          </Col>
        </Row>
        {this.isAdmin() && this.props.deleteMatch && (
          <Row>
            <Col className="text-right" md={12}>
              <Button className="btn-blue" onClick={() => this.modalToggle()}>
                Discard
              </Button>
            </Col>
          </Row>
        )}
        <ConfirmationModal
          isOpen={this.state.showDelete}
          toggle={() => {
            this.modalToggle();
          }}
          title={'Discard Match'}
          description={
            this.props.deleting
              ? 'Discarding match...'
              : 'Are you sure you want to discard this match'
          }
          onContinue={this.props.deleteMatch(matchId)}
          loading={this.props.deleting}
          showButtons={!this.props.deleting}
        />
      </Col>
    );
  }
}
const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth,
});
export default connect(mapStateToProps)(MatchDetail);



// WEBPACK FOOTER //
// ./src/modules/Recognition/Match/components/Webiq/components/MatchDetail.tsx